import { atom } from 'jotai';

export interface BatchPatient {
  unifiedId: string | number;
  estimatedVisitId?: number;
  imagingPatientId?: string;
}

// user clicked push to pms, download pdf, or download pieces
export type BatchResultStatus = 'attempted';

export interface BatchSession {
  patients: BatchPatient[];
  startedAt: number;
  results: Record<string, BatchResultStatus>;
}

export const batchSessionAtom = atom<BatchSession | null>(null);

// Shared atom so ClaimsTopbarContent can read the count without prop-drilling.
export const batchReadyPatientsAtom = atom<BatchPatient[]>([]);

export function setBatchResult(
  prev: BatchSession | null,
  unifiedId: string | number,
  status: BatchResultStatus,
): BatchSession | null {
  if (!prev) return prev;
  const id = String(unifiedId);
  return {
    ...prev,
    results: { ...prev.results, [id]: status },
  };
}
